import React, { FC, memo } from 'react';

import { getActions, withGlobal } from '../../../global';
import IconSvgPayment from '../IconSvgPayment';
import Modal from '../../ui/Modal';
import IconSvg from '../../ui/IconSvg';
import Button from '../../ui/Button';

import classNames from 'classnames';
import { AiPrompt, AiPurchaseType } from '../../../global/types';

export type OwnProps = {
  isOpen: boolean;
  type?: string;
  namePurchase: string;
  purchaseData: AiPrompt;
  onClose: () => void;
  onCloseAnimationEnd?: () => void;
};

const ConfirmPurchaseAi: FC<OwnProps> = ({
  isOpen,
  onClose,
  type,
  namePurchase,
  purchaseData,
}) => {
  const { subscribeAi } = getActions();

  const handleSubscribe = () => {
    subscribeAi({
      sub_type: AiPurchaseType[`${namePurchase}_${type}`],
      quantity:
        type === 'subscription' || Array.isArray(purchaseData?.count)
          ? undefined
          : purchaseData?.count,
    });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      className='confirm payment-confirm'
      onClose={onClose}
      centered
      hasCloseButton
    >
      <div className='modal-content'>
        <h3>Confirm purchase</h3>
        <div className='pair-icon'>
          <div className={`icon-svg ai-${namePurchase}`}>
            <IconSvgPayment
              name={namePurchase === 'img' ? 'img-fill' : namePurchase}
              w='32'
              h='32'
            />
          </div>
          <div className='icon-svg main'>
            <IconSvg name='ai-bot' w='54' h='54' />
          </div>
        </div>

        <div
          className={classNames('price-wrap', {
            'direction-column': Array.isArray(purchaseData?.count),
          })}
        >
          {Array.isArray(purchaseData?.count) ? (
            purchaseData!.count.map((qty, idx) => (
              <div key={idx} className='prompts'>
                <span className='flash-prompt'>
                  <IconSvgPayment
                    name={type === 'subscription' ? 'infinity' : 'flash'}
                  />
                  {type === 'pack' && qty}
                </span>
                {idx === 0
                  ? type === 'subscription'
                    ? 'Unlimited chat prompts'
                    : 'Chat prompts'
                  : type === 'subscription'
                  ? 'Unlimited image prompts'
                  : 'Image prompts'}
              </div>
            ))
          ) : (
            <div className='prompts'>
              <span className='flash-prompt'>
                <IconSvgPayment
                  name={type === 'subscription' ? 'infinity' : 'flash'}
                />
                {type === 'pack' && purchaseData?.count}
              </span>
              <span>
                {namePurchase === 'text'
                  ? type === 'subscription'
                    ? 'Unlimited prompts'
                    : 'Chat prompts'
                  : type === 'subscription'
                  ? 'Unlimited prompts'
                  : 'Image prompts'}
              </span>
            </div>
          )}

          <div className='price'>
            <IconSvg name='dollar' w='20' h='20' />

            {type === 'subscription' ? (
              <>
                <span>
                  {purchaseData?.unlim}
                  <i>/mo.</i>
                </span>
              </>
            ) : (
              <span> {purchaseData?.price} </span>
            )}
          </div>
        </div>
        <div className='dialog-buttons'>
          <Button onClick={handleSubscribe}>Buy</Button>
        </div>
        {/* <div className='notification'>
          <IconSvg name='info-circle' w='18' h='18' />
          <p>
            <b>Note!</b> At the end of the month, the number of requests is
            reset to zero.
          </p>
        </div> */}
      </div>
    </Modal>
  );
};

export default memo(ConfirmPurchaseAi);
